import styled from 'styled-components';
import { isConstruction } from 'config';

export const Container = styled.div`
  margin-bottom: 24px;
`;

type Props = {
  $maxHeight: number;
};

export const DescriptionText = styled.p<Props>`
  overflow: hidden;
  font-size: 16px;
  line-height: 24px;
  max-height: ${({ $maxHeight }) => $maxHeight}px;
  transition: max-height 0.3s ease;
`;

export const ToggleButton = styled.button`
  appearance: none;
  background: none;
  border: none;
  padding: 8px 0;
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${({ theme }) => theme.colors[isConstruction ? 'black' : 'grey6']};
  font-weight: ${isConstruction ? 'bold' : 'regular'};
  font-size: 14px;
  text-transform: ${isConstruction ? 'uppercase' : 'initial'};
  text-decoration: ${isConstruction ? 'none' : 'underline'};
  cursor: pointer;
`;
